/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.publicBusinessSettings.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * business public settings data
 */
@ExperimentalJsExport
@JsExport
@Serializable
data class PublicBusinessSettingsData(
    /** business */
    @SerialName("business")
    val business: BusinessData?
)
